import { render, staticRenderFns } from "./InvoiceClient.vue?vue&type=template&id=615a3ec3"
import script from "./InvoiceClient.vue?vue&type=script&lang=js"
export * from "./InvoiceClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports